import apiClient from './apiClient';

export const getMyCompanyDetails = async () => {
    try {
        const response = await apiClient.get('/companies/my-company');
        return response.data;
    } catch (error) {
        throw error;
    }
};
